import { useTranslation } from "@/app/i18n/client";

export default async function ExpiredPage() {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center h-screen bg-gray-100 px-3">
            <div className="bg-white shadow-lg md:p-14 p-6 rounded-md">
                <div className="text-center space-y-5">
                    <h1 className="md:text-4xl text-3xl font-bold text-black">{t("websiteExpired.title")}</h1>
                    <p className="mt-4 text-lg text-gray-700">{t("websiteExpired.desc")}</p>
                </div>
            </div>
        </div>
    );
}
